<template>
  <svg class="progress-wrapper" :width="radius * 2 + 6" :height="radius * 2 + 6" viewBox="0 0 60 60">
    <circle
      class="circle"
      cx="50%"
      cy="50%"
      :r="radius"
      stroke="white"
      stroke-width="4"
      :stroke-dasharray="dashArray"
      :fill="full ? '#2c70c9' : '#546f92'"
      transform="rotate(-90,30,30)"
    ></circle>
    <text
      :x="progress === 100 ? '27%' : progress > 9.5 ? '32%' : '37%'"
      y="45%"
      fill="white"
      stroke-width="0"
      dy="1px"
      font-size="14px"
      font-weight="bold"
    >
      {{ progress.toFixed() }}%
    </text>
    <text class="match" x="25%" y="65%" stroke-width="0" dy="1px" font-size="10px">
      MATCH
    </text>
  </svg>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Progress',
  props: {
    progress: Number,
    full: Boolean,
  },
  data() {
    return {
      radius: 27,
    };
  },
  computed: {
    dashArray() {
      const progressLength = (2 * Math.PI * this.radius * this.progress) / 100;
      const rest = 2 * Math.PI * this.radius;
      return `${progressLength} ${rest}`;
    },
  },
});
</script>

<style scoped>
.progress-wrapper {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;
}

.match {
  fill: #fff;
  opacity: 0.7;
}
</style>
